class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    /* Toast notification disabled — open the cart drawer instead so customer
       sees the free-shipping bar + items + checkout buttons in one view. */
    const dropdown = document.getElementById('cart-icon-bubble');
    const drawer = dropdown && dropdown.querySelector('.dropdown-menu');
    const toggle = document.getElementById('toggleCountCart');
    if (dropdown) dropdown.classList.add('show');
    if (drawer) drawer.classList.add('show');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section => {
        if (section.id === 'cart-icon-bubble') return;
        const target = document.getElementById(section.id);
        const html = parsedState.sections && parsedState.sections[section.id];
        if (!target || !html) return;
        try {
          target.innerHTML = this.getSectionInnerHTML(html, section.selector);
        } catch (e) {
          console.warn('[cart-notification] render skip', section.id, e.message);
        }
      }));

      this.refreshCartBadge();

      if (this.header) this.header.reveal();
      this.open();
      document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  refreshCartBadge() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then((r) => r.json())
      .then((cart) => {
        const countEl = document.getElementById('Cartcount');
        if (countEl) countEl.textContent = cart.item_count;
        const totalEl = document.getElementById('CartTotalText');
        if (totalEl) {
          if (window.Shopify && window.Shopify.formatMoney) {
            totalEl.innerHTML = window.Shopify.formatMoney(
              cart.total_price,
              window.Shopify.money_format || '${{amount}}'
            );
          } else {
            totalEl.textContent = '$' + (cart.total_price / 100).toFixed(2);
          }
        }
      })
      .catch(() => {});

    fetch('/?section_id=header', { credentials: 'same-origin' })
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newDrawer = doc.querySelector('#cart-icon-bubble .dropdown-menu');
        const oldDrawer = document.querySelector('#cart-icon-bubble .dropdown-menu');
        if (!newDrawer || !oldDrawer) return;

        /* Preserve Bootstrap dropdown open state across innerHTML replacement. */
        const dropdown = document.getElementById('cart-icon-bubble');
        const toggle = document.getElementById('toggleCountCart');
        const wasOpen =
          (oldDrawer.classList.contains('show')) ||
          (dropdown && dropdown.classList.contains('show')) ||
          (toggle && toggle.getAttribute('aria-expanded') === 'true');

        oldDrawer.innerHTML = newDrawer.innerHTML;

        if (wasOpen) {
          oldDrawer.classList.add('show');
          if (dropdown) dropdown.classList.add('show');
          if (toggle) toggle.setAttribute('aria-expanded', 'true');
        }

        /* Sync-render the new free-shipping bar from the data attributes that
           were just rendered server-side. Avoids the 0%→actual flash that
           happens if we wait for cart:updated → fetch /cart.js → render. */
        if (window.aeRenderBar && window.AE_ZONE) {
          const newBar = oldDrawer.querySelector('#aeFreeShipBar');
          if (newBar) {
            const total = parseInt(newBar.dataset.cartTotal || '0', 10);
            const count = parseInt(newBar.dataset.cartCount || '0', 10);
            window.aeRenderBar(window.AE_ZONE, total, count);
          }
        }

        /* Notify other listeners (clears optimistic placeholders, etc) */
        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(() => {});
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return '';
    try {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const el = doc.querySelector(selector);
      return el ? el.innerHTML : '';
    } catch { return ''; }
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
